import { IActionReducer } from "../../../redux/action.types"
import { minigridTypes } from "./minigrid.types"

export interface IMinigridState {
    isLoadingListMinigrid: boolean
    querySearch: string | null
}

const INITIAL_STATE: IMinigridState = {
    isLoadingListMinigrid: false,
    querySearch: null
}

const minigridReducer = (state: IMinigridState = INITIAL_STATE, action:  IActionReducer) => {
    switch (action.type) {
        case minigridTypes.IS_LOADING_LIST_MINIGRID:
            return {
                ...state,
                isLoadingListMinigrid: action.payload
            }
        case minigridTypes.SET_QUERY_SEARCH:
            return {
                ...state,
                querySearch: action.payload
            }
        default:
            return state
    }
}

export default minigridReducer